module.exports = __webpack_public_path__ + "static/media/google-play-badge5.a10a6188.png";